import React, { useEffect } from 'react';
import Select from 'react-select';
import lodash from 'lodash';
import PropTypes from 'prop-types';

// Initialize the selected value by Id property of the value
const withOptionsSelectValueInitById = (options) => {
   const InnerComponent = ({
      className: propsClassName = '',
      ...props
   }) => {
      // useEffect(() => {
      //    if (defaultValue && props.onChange) {
      //       props.onChange(defaultValue);
      //    }
      // }, [])

      // The value of this select component must always be an object, besides the case when the value is initially a
      // string

      // If the value is a string then find the option with this value
      // Usage: filter initialization. A Select component may have just the value stored in the queryString

      useEffect(() => {
         const { value } = props;

         if (typeof value === 'string') {
            // Initialize by ID if ALL options have a value defined by ID
            // Otherwise use the 'value' property of the options
            const allOptionsHasIdProperty = options.every((optionItem) => optionItem?.id !== undefined);

            const selectedOption = allOptionsHasIdProperty
               ? options.find((option) => value === option.id)
               : options.find((option) => value === option.value);

            if (selectedOption !== undefined) {
               props.onChange(selectedOption);
            }
         } else if (
            value !== undefined
            && value !== null
            && lodash.isObject(value)
            && !value.hasOwnProperty('value')
            && value.hasOwnProperty('id')
         ) {
            const selectedOption = options.find((option) => value.id === option.id);
            if (selectedOption !== undefined) {
               props.onChange(selectedOption);
            }
         }
      }, [props.value]);

      return (
         <Select
            name={props.name}
            value={props.value}
            className={`react-select-container ${ propsClassName }`}
            classNamePrefix='react-select'
            onChange={props.onChange}
            onBlur={props.onBlur}
            options={options}
            isDisabled={props.isDisabled}
            isSearchable={props.isSearchable}
            isOptionDisabled={props.isOptionDisabled}
         />
      );
   };

   InnerComponent.propTypes = {
      className: PropTypes.string,
      onChange: PropTypes.func.isRequired,
      value: PropTypes.oneOfType([PropTypes.objectOf(PropTypes.any), PropTypes.string]),
      name: PropTypes.string.isRequired,
      onBlur: PropTypes.func,
      isDisabled: PropTypes.bool,
      isOptionDisabled: PropTypes.func,
      isSearchable: PropTypes.bool,
   };

   InnerComponent.defaultProps = {
      className: '',
      value: null,
      onBlur: undefined,
      isDisabled: false,
      isOptionDisabled: undefined,
      isSearchable: false,
   };

   return InnerComponent;
};

export default withOptionsSelectValueInitById;
